module.exports = __webpack_public_path__ + "static/img/i2.e0a05f3f.png";